module.exports = __webpack_public_path__ + "img/icons BFr_38.523c94f0.svg";